
const labels = {
  addRemoveLabel: 'ADD/REMOVE',
  arrivalAirports: 'Example: PDX or Portland International Airport',
  departureAirports: 'Example: PDX or Portland International Airport',
  airlines: 'Example: AA or American Airlines',
  arrivalRegions: 'Example: North America',
  departureRegions: 'Example: North America',
  arrivalCountries: 'Example: United States',
  departureCountries: 'Example: United States',
};

const modalLabelMapping = {
  airlines: 'Airlines',
  arrivalAirports: 'Arrival Airports',
  departureAirports: 'Departure Airports',
  arrivalCountries: 'Countries',
  departureCountries: 'Countries',
  arrivalRegions: 'Regions',
  departureRegions: 'Regions',
};

const searchCategories = [
  {
    label: 'Airports',
    value: 'airport',
  },
  {
    label: 'Countries',
    value: 'countries',
  },
  {
    label: 'Regions',
    value: 'regions',
  },
];

const fieldMappingByExportType = {
  arriving: [
    {
      fieldType: 'arrivalAirports',
      label: 'Arrival Airport(s)',
    },
    {
      fieldType: 'arrivalCountries',
      label: 'Arrival Countries',
    },
    {
      fieldType: 'arrivalRegions',
      label: 'Arrival Regions',
    },
  ],
  departing: [
    {
      fieldType: 'departureAirports',
      label: 'Departure Airport(s)',
    },
    {
      fieldType: 'departureCountries',
      label: 'Departure Countries',
    },
    {
      fieldType: 'departureRegions',
      label: 'Departure Regions',
    },
  ],
  deparr: [
    {
      fieldType: 'arrivalAirports',
      label: 'Departure or Arrival Airport(s)',
    },
    {
      fieldType: 'arrivalCountries',
      label: 'Departure or Arrival Countries',
    },
    {
      fieldType: 'arrivalRegions',
      label: 'Departure or Arrival Regions',
    },
  ],
  route: [
    {
      fieldType: 'arrivalAirports',
      label: 'Arrival Airport(s)',
    },
    {
      fieldType: 'departureAirports',
      label: 'Departure Airport(s)',
    },
    {
      fieldType: 'arrivalCountries',
      label: 'Arrival Countries',
    },
    {
      fieldType: 'departureCountries',
      label: 'Departure Countries',
    },
    {
      fieldType: 'arrivalRegions',
      label: 'Arrival Region(s)',
    },
    {
      fieldType: 'departureRegions',
      label: 'Departure Region(s)',
    },
  ],
};

export {
  fieldMappingByExportType,
  labels,
  modalLabelMapping,
  searchCategories,
};



// WEBPACK FOOTER //
// ./modules/DataExports/components/ExportsSearch/children/CompileDataForm/constants.js